/** Ensure Emotion initializes before MUI modules that call `styled()` (Vite dev prebundle order). */
import '@emotion/react'
import '@emotion/styled'
import '@fontsource/inter/300.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/inter/800.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { registerGlobalErrorHandlers } from '@/lib/global-error-handlers'
import { consumeTenantHandoffFromLocation } from '@/lib/handoffBootstrap'
import { disableBrowserScrollRestoration } from '@/shared/hooks/useScrollAppShellMainToTop'
import App from './app/App'

registerGlobalErrorHandlers()
disableBrowserScrollRestoration()

await consumeTenantHandoffFromLocation()
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
